(function haSteps() {
  const isCompExists = GlobalSite.checkDependency('GlobalSite.isCompExists');
  const compName = 'ha_list-article-more';
  const logFactory = GlobalSite.checkDependency('GlobalSite.logFactory');
  const Log = logFactory(`${compName}.js`);

  if (!isCompExists(compName, Log)) {
    return;
  }

  const getCmonMagArticles = GlobalSite.checkDependency('GlobalSite.getCmonMagArticles');
  $(async () => {
    let page = 2;
    let $html = '';
    const $ul = $('.list-article__items');
    const getTitle = (item) => item.title || '';
    const getImage = (item) => (item.image ? `<img src="${item.image}">` : '');
    const getDate = (item) => item.date || '';
    const getDescription = (item) =>
      (item.description ? `<p class="card-article__desc">${item.description}</p>` : '');
    $('.pagination button').on('click', async () => {
      const data = await getCmonMagArticles(page);
      data.articles.map((item) => {
        $html += `<li class="cell article__body text-center large-6 medium-12">
          ${getImage(item)}
          <a class="card-article text-center grid-x" href="${item.path}">
          <div class="card-article__stripe"></div>
          <span class="card-article__tag">${item.category}</span>
          <div class="card-article__text large-offset-2 medium-offset-1 small-offset-1 large-8 medium-10 small-10">
          <span class="card-article__title">${getTitle(item)}</span>
          <span class="card-article__date">${getDate(item)}</span>
          ${getDescription(item)}</div></a></li>`;
        return $html;
      });
      $ul.append($html);
      page += 1;
      $html = '';
    });
  });
})();
